// @ts-nocheck
import { hubService } from '@/services';
export default {
    // 라이더 관리 배달대행료 수수료 그룹 (C,R,U,D)
    /**
     * 라이더 관리 배달대행료 수수료 그룹 생성
     * @param {object} payload
     * @param {string} payload.name 생성할 수수료 그룹의 이름.
     * @param {number} payload.dayFeeCount 생성할 수수료 그룹의 일일 수수료 차감 건수.
     */
    async postWorkerDeliveryFeeGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const response = await hubService.postWorkerDeliveryFeeGroup({
            hubId,
            payload,
        });
        commit('POST_WORKER_DELIVERY_FEE_GROUP', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 조회
     */
    async getWorkerDeliveryFeeGroupList({ commit, rootGetters }) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeOnlyHubId'];
        const response = await hubService.getWorkerDeliveryFeeGroup({
            hubId,
        });
        const workerEditGroup = rootGetters['workerManagement/workerEdit/getterSelectedWorkerDetailDeliveryFeeGroup'];
        // 라이더 수정 시 현재 소속 그룹 최상단
        if (workerEditGroup) {
            response.data = response.data
                .filter((group) => group.id !== workerEditGroup.id);
            response.data.unshift(workerEditGroup);
        }
        commit('GET_WORKER_DELIVERY_FEE_GROUP_LIST', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 수정
     * @param {object} payload
     * @param {number} payload.groupId 수정할 수수료 그룹.
     * @param {string} payload.name 수정할 수수료 그룹의 이름.
     * @param {number} payload.dayFeeCount 수정할 수수료 그룹의 이름.
     */
    async putWorkerDeliveryFeeGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.putWorkerDeliveryFeeGroup({
            hubId,
            id: groupId,
            payload,
        });
        commit('PUT_WORKER_DELIVERY_FEE_GROUP', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 삭제
     * @param {object} payload
     * @param {number} payload.groupId 삭제할 수수료 그룹.
     */
    async deleteWorkerDeliveryFeeGroup({ state, commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.deleteWorkerDeliveryFeeGroup({
            hubId,
            id: groupId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const deletedFeeGroupList = state.workerDeliveryFeeGroupList
            .filter((group) => group.id !== groupId);
        commit('DELETE_WORKER_DELIVERY_FEE_GROUP', deletedFeeGroupList);
        commit('PUBLISH_WORKER_DELIVERY_FEE_GROUP_DELETED', groupId);
    },
    // 라이더 관리 배달대행료 수수료 설정 (C,R,U,D)
    /**
     * 라이더 관리 배달대행료 수수료 설정 생성
     * @param {object} payload
     * @param {number} payload.groupId 수수료 설정을 생성할 그룹.
     * @param {number} payload.fromAmount 생성할 수수료 설정의 시작 구간(금액).
     * @param {number} payload.toAmount 생성할 수수료 설정의 종료 구간(금액).
     * @param {number} payload.fee 생성할 수수료 설정의 수수료 정액.
     * @param {number} payload.rate 생성할 수수료 설정의 수수료 정률.
     */
    async postWorkerDeliveryFeeGroupOption({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.postWorkerDeliveryFeeGroupOption({
            hubId,
            groupId,
            payload,
        });
        commit('POST_WORKER_DELIVERY_FEE_GROUP_OPTION', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 설정 조회
     * @param {object} payload
     * @param {number} payload.groupId 수수료 설정을 조회할 그룹.
     */
    async getWorkerDeliveryFeeGroupOptionList({ commit, rootGetters }, payload = {}) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeOnlyHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.getWorkerDeliveryFeeGroupOption({
            hubId,
            groupId,
        });
        commit('GET_WORKER_DELIVERY_FEE_GROUP_OPTION_LIST', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 설정 수정
     * @param {object} payload
     * @param {number} payload.groupId 수정할 수수료 설정이 속한 그룹.
     * @param {number} payload.optionId 수정할 수수료 설정.
     * @param {number} payload.fromAmount 수정할 수수료 설정의 시작 구간(금액).
     * @param {number} payload.toAmount 수정할 수수료 설정의 종료 구간(금액).
     * @param {number} payload.fee 수정할 수수료 설정의 수수료 정액.
     * @param {number} payload.rate 수정할 수수료 설정의 수수료 정률.
     */
    async putWorkerDeliveryFeeGroupOption({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', optionId = '' } = payload;
        const response = await hubService.putWorkerDeliveryFeeGroupOption({
            hubId,
            groupId,
            id: optionId,
            payload,
        });
        commit('PUT_WORKER_DELIVERY_FEE_GROUP_OPTION', response.data);
    },
    /**
     * 라이더 관리 배달대행료 수수료 설정 삭제
     * @param {object} payload
     * @param {number} payload.groupId 삭제할 수수료 설정이 속한 그룹.
     * @param {number} payload.optionId 삭제할 수수료 설정.
     */
    async deleteWorkerDeliveryFeeGroupOption({ state, commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', optionId = '' } = payload;
        const response = await hubService.deleteWorkerDeliveryFeeGroupOption({
            hubId,
            groupId,
            id: optionId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const deletedFeeGroupOptionList = state.workerDeliveryFeeGroupOptionList
            .filter((option) => option.id !== optionId);
        commit('DELETE_WORKER_DELIVERY_FEE_GROUP_OPTION', deletedFeeGroupOptionList);
    },
    setSelectedFeeGroup({ commit }, group = {}) {
        commit('SET_SELECTED_FEE_GROUP', group);
    },
    // 다이얼로그 핸들링
    setOpenEditGroupDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_GROUP_DIALOG', isOpen);
    },
    setOpenEditOptionDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_OPTION_DIALOG', isOpen);
    },
    setEditGroupItem({ commit }, item = {}) {
        commit('SET_EDIT_GROUP_ITEM', item);
    },
    setEditOptionItem({ commit }, item = {}) {
        commit('SET_EDIT_OPTION_ITEM', item);
    },
    // 초기화
    clearDeliveryFeeGroupDialog({ commit }) {
        commit('CLEAR_WORKER_DELIVERY_FEE_GROUP_LIST');
        commit('CLEAR_WORKER_DELIVERY_FEE_GROUP_OPTION_LIST');
        commit('CLEAR_SELECTED_FEE_GROUP');
    },
    clearWorkerDeliveryFeeGroupList({ commit }) {
        commit('CLEAR_WORKER_DELIVERY_FEE_GROUP_LIST');
    },
    clearWorkerDeliveryFeeGroupOptionList({ commit }) {
        commit('CLEAR_WORKER_DELIVERY_FEE_GROUP_OPTION_LIST');
    },
    clearSelectedFeeGroup({ commit }) {
        commit('CLEAR_SELECTED_FEE_GROUP');
    },
    // 라이더 수수료 그룹 변경 다이얼로그 전용
    setOpenFeeGroupSelectDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_FEE_GROUP_SELECT_DIALOG', isOpen);
    },
};
